module.exports = __webpack_public_path__ + "static/media/007-Tablett_Abraumen_ID_1.0027ea2b.mp3";